import momentEu from 'moment/locale/eu';
import merchantIp from './en/merchantip';
import transactionRecord from './en/transactionRecord';
import transaction from './en/transaction';
import userTransaction from './en/userTransaction';
import withdrawBank from './en/withdrawBank';
import home from './en/home';
import passwd from './en/passwd';
import btns from './en/btns';
import withdraw from './en/withdraw';
import merchantdeposit from './en/merchantdeposit.js';
import status from './en/status';
import clientmanage from './en/clientmanage';
import login from './en/login';
import orders from './en/orders';
import rolemanager from './en/rolemanager';
import wallet from './en/walletRecord';
import merchantdetails from './en/merchantdetails';
import menumanage from './en/menumanage';
import accountmanager from './en/accountmanager';
import channel from './en/channel';
import welcome from './en/welcome';
import merchantBalance from './en/merchantBalance';
import channelTest from './en/channelTest';
import momoLogs from './en/momoLogs';
import usdt from './en/usdt';
import sysConfig from './en/sysConfig';
import device from './en/device';
import channelList from './en/channelList';

const components = {
  momentName: 'eu',
  momentLocale: momentEu
};

const langs = {
  /* -------------------------------------------------------------------------- */
  /*                              @NOTE global 全局翻译                             */
  tips: {
    tip1: 'This is a piece of content, are you sure to delete it?',
    tip2: 'You have a new withdrawal order of {money} VND',
    tip3: 'You have a new payment order of {money} VND '
  },
  btns,
  status,
  /*                              @NOTE global 全局翻译                             */
  /* -------------------------------------------------------------------------- */

  /* -------------------------------------------------------------------------- */
  /*                                @NOTE 页面翻译文件                                */
  momoLogs,
  merchantIp,
  transaction,
  transactionRecord,
  userTransaction,
  withdrawBank,
  withdraw,
  merchantdeposit,
  passwd,
  clientmanage,
  login,
  home,
  channel,
  wallet,
  orders,
  accountmanager,
  menumanage,
  rolemanager,
  merchantdetails,
  merchantBalance,
  welcome,
  channelTest,
  usdt,
  sysConfig,
  device,
  channelList
  /*                                @NOTE 页面翻译文件                                */
  /* -------------------------------------------------------------------------- */
};

export default { ...langs, ...components };



// WEBPACK FOOTER //
// ./src/i18n/lang/en.js